<template>
  <div>
    <LeftSideBar
      :newVisibleLeft="newVisibleLeft"
      :hoverVariable="hoverVariable"
      :hoverVariableSubItem="hoverVariableSubItem"
      :newSelectedAnalysis="newSelectedAnalysis"
      :newSelectedAnalysisParent="newSelectedAnalysisParent"
      :itemsInformation="itemsInformationSideBar"
      @onHoverLeftSidebar="onHoverLeftSidebar"
      @onHoverLeftSidebarSubItem="onHoverLeftSidebarSubItem"
      @onLeftSidebarAnalysis="onLeftSidebarAnalysis"
      @eventOnUserClick="onUserClickLeftSidebarShow"
      @onLeftSidebarAnalysisScenarios="onLeftSidebarAnalysisScenarios"
      @eventOnSidebarItemsChange="onSidebarItemsChange"
    />
  </div>
</template>

<script>
import LeftSideBar from "../sideBars/LeftSideBar.vue";

export default {
  name: "LeftSidebarAnalytics",
  components: {
    LeftSideBar
  },
  props: {
    selectedAnalysis: { required: true, default: "" },
    selectedAnalysisParent: { required: true, default: "" },
    visibleLeft: { required: true, type: Boolean, default: false },
    selectedChildName: { required: false, type: Object, default: () => ({}) }
  },
  data() {
    return {
      hoverVariable: "",
      hoverVariableSubItem: "",
      newSelectedAnalysis: "valuation",
      newSelectedAnalysisParent: "",
      newVisibleLeft: false,
      itemsInformationSideBar: [
        {
          text: "",
          nameEvent: "",
          bdr: false,
          itemHeader: false,
          classNameIcon: "",
          bdrTransition: false
        }
      ]
    };
  },
  created() {
    this.setItemsSideBar();
  },
  mounted() {
    this.newSelectedAnalysis = this.selectedAnalysis;
    this.newSelectedAnalysisParent = this.selectedAnalysisParent;
    this.newVisibleLeft = this.visibleLeft;
  },
  watch: {
    itemsInformationSideBar: {
      handler(items) {
        this.$emit("eventOnSidebarItemsChange", items);
      },
      deep: true
    },
    selectedAnalysis(val) {
      this.newSelectedAnalysis = val;
    },
    selectedAnalysisParent(val) {
      this.newSelectedAnalysisParent = val;
    },
    visibleLeft(val) {
      this.newVisibleLeft = val;
    },
    selectedChildName(val) {
      if (!val) return;

      this.newSelectedAnalysis = val.selectedAnalysis;
      this.newSelectedAnalysisParent = val.selectedAnalysisParent;
    }
  },
  methods: {
    onHoverLeftSidebar(val) {
      this.hoverVariable = val;
    },
    onHoverLeftSidebarSubItem(val) {
      this.hoverVariableSubItem = val;
    },
    onUserClickLeftSidebarShow() {
      this.$emit("eventOnUserClickLeftSidebarShow", !this.visibleLeft);
    },
    onLeftSidebarAnalysisScenarios(event) {
      this.hoverVariable = "";
      this.$emit("onLeftSidebarAnalysisScenarios", event);
    },
    onLeftSidebarAnalysis({ val, parent }) {
      this.$emit("eventOnLeftSidebarAnalysis", { val, parent });
    },
    onSidebarItemsChange(items) {
      Object.assign(this.itemsInformationSideBar, items);
    },
    setItemsSideBar() {
      Object.assign(this.itemsInformationSideBar, [
        // {
        //   text: "GENERAL",
        //   nameEvent: "general",
        //   bdr: true,
        //   itemHeader: true,
        //   classNameIcon: "G",
        //   bdrTransition: true
        // },
        // {
        //   text: "Breakdown",
        //   nameEvent: "portfolio",
        //   bdr: false,
        //   itemHeader: false,
        //   classNameIcon: "fa fa-pie-chart",
        //   bdrTransition: false
        // },
        {
          text: "Valuation",
          nameEvent: "valuation",
          bdr: false,
          itemHeader: false,
          itemParent: true,
          classNameIcon: "pi pi-check-square",
          bdrTransition: false,
          index: 0,
          routeName: "analytics-valuation"
        },
        {
          text: "Management",
          nameEvent: "contractManagement",
          bdr: false,
          itemHeader: false,
          itemParent: true,
          classNameIcon: "pi pi-chart-bar",
          bdrTransition: true,
          index: 1,
          routeName: "analytics-management"
        },
        // {
        //   text: "Scenarios and risk",
        //   nameEvent: "future",
        //   bdr: false,
        //   itemHeader: false,
        //   classNameIcon: "fa fa-wifi fa-rotate-90",
        //   bdrTransition: true
        // },
        // {
        //   text: "Historical Results",
        //   nameEvent: "past",
        //   bdr: false,
        //   itemHeader: false,
        //   classNameIcon: "pi pi-history",
        //   bdrTransition: true
        // },
        {
          text: "Analysis",
          nameEvent: "scenarios",
          bdr: false,
          itemHeader: false,
          itemParent: true,
          classNameIcon: "pi pi-align-center fa-rotate-90",
          bdrTransition: true,
          index: 2,
          routeName: "analytics-scenarios",
          children: [
            {
              text: "Portfolio",
              nameEvent: "scenario",
              nameEventParent: "scenarios",
              index: 0,
              routeName: "analytics-scenarios-portfolio"
            },
            {
              text: "Strategies",
              nameEvent: "strategies",
              nameEventParent: "scenarios",
              index: 1,
              routeName: "analytics-scenarios-strategies"
            },
            {
              text: "Derivatives",
              nameEvent: "derivatives",
              nameEventParent: "scenarios",
              index: 2,
              routeName: "analytics-scenarios-derivatives"
            },
            {
              text: "Suppliers",
              nameEvent: "providers",
              nameEventParent: "scenarios",
              index: 3,
              routeName: "analytics-scenarios-providers"
            },
            {
              text: "Clients",
              nameEvent: "clients",
              nameEventParent: "scenarios",
              index: 4,
              routeName: "analytics-scenarios-clients"
            },
            {
              text: "Counterparty",
              nameEvent: "counterparty",
              nameEventParent: "scenarios",
              index: 5,
              routeName: "analytics-scenarios-counterparty"
            }
          ]
        }
        // {
        //   text: "Cash Flow Builder",
        //   nameEvent: "cf_projection",
        //   bdr: true,
        //   itemHeader: false,
        //   classNameIcon: "pi pi-chart-bar",
        //   bdrTransition: true
        // },
        // {
        //   text: "BALANCE RISK MANAGEMENT",
        //   nameEvent: "balance",
        //   bdr: true,
        //   itemHeader: true,
        //   classNameIcon: "BAL",
        //   bdrTransition: true
        // },
        // {
        //   text: "Balance Exposure Projection",
        //   nameEvent: "b_projection",
        //   bdr: false,
        //   itemHeader: false,
        //   classNameIcon: "fa fa-calendar",
        //   bdrTransition: true
        // },
        // {
        //   text: "Schedule and Rates",
        //   nameEvent: "rates",
        //   bdr: false,
        //   itemHeader: false,
        //   classNameIcon: "pi pi-chart-bar fa-rotate-90",
        //   bdrTransition: true
        // },
        // {
        //   text: "Scenarios and Risk",
        //   nameEvent: "b_future",
        //   bdr: true,
        //   itemHeader: false,
        //   classNameIcon: "fa fa-wifi fa-rotate-90",
        //   bdrTransition: true
        // },
        // {
        //   text: "CASH FLOW RISK MANAGEMENT",
        //   nameEvent: "cashFlow",
        //   bdr: true,
        //   itemHeader: true,
        //   classNameIcon: "CF",
        //   bdrTransition: true
        // },
        // {
        //   text: "Consolidated results",
        //   nameEvent: "consolidated",
        //   bdr: false,
        //   itemHeader: false,
        //   classNameIcon: "fa fa-table",
        //   bdrTransition: true
        // },
      ]);
    }
  }
};
</script>
